import React from 'react'
import { Images } from '../../../utils/imageConstants'

interface SidebarArrowProps {
  isOpen: boolean
  onToggle: () => void
}

const SidebarArrow: React.FC<SidebarArrowProps> = ({ isOpen, onToggle }) => {
  return (
    <div 
      className={`statgpt-sidebar-arrow ${isOpen ? 'open' : 'closed'}`}
      onClick={onToggle}
      style={{ cursor: 'pointer' }}
    >
      <div className="statgpt-arrow-container">
        <div className="statgpt-arrow-icon">
          <img src={Images.side_arrow_icon} alt="Arrow" />
        </div>
      </div>
    </div>
  )
}

export default SidebarArrow

